import {Injectable} from '@angular/core';
import {BaseService} from './base-service';
import {MenuModifierSelection} from '../_models/menu-modifier-selection';

@Injectable({
    providedIn: 'root'
})
export class MenuModifierSelectionService extends BaseService<MenuModifierSelection> {
    destination = 'menu-modifier-selections';
}
